import styled from '@emotion/styled';
import { Paper, Typography } from '@material-ui/core';
import React from 'react';
import { Box } from '../UI';
import './global.css';
import Header from './Header';

export default function Layout({ children, path }) {
	return (
		<div style={{ position: 'relative' }}>
			<Header path={path} />
			<Mobile>
				<Paper style={{ padding: '15px' }}>
					<Typography variant="h4" style={{ marginBottom: '1rem' }}>
						<strong>aXcess Mobile Application</strong>
					</Typography>
					<Typography variant="body1">
						Unfortunately we do not currently support aXcess on mobile devices. You can always visit the
						dashboard on your computer.
					</Typography>
				</Paper>
			</Mobile>
			<Desktop>{children}</Desktop>
		</div>
	);
}

const Mobile = styled(Box)`
	padding: 30px;
	@media (min-width: 900px) {
		display: none;
	}
`;
const Desktop = styled(Box)`
	@media (max-width: 900px) {
		display: none;
	}
`;
